<template>
    <div class="render-post hide-scrollbar render-post-google">

        <div class="post-content">
            <div class="post-header">
                <div class="img-pages">

                    <template v-for="(picturePage, index) in picturePages.slice(0,picturePages.length == 4 ? 4 : 3)" >
                        <Tooltip :key="index" :active="picturePage.iconEdited" :text="'Voir les modifications apportées'" position="right" :classCustom="`page ${picturePage.iconEdited ? 'iconEdited' : ''}`" @click="()=>{$emit('clickPage', picturePage.id)}" >
                            <img :src="picturePage && picturePage.avatar ? picturePage.avatar : 'img/avatar.jpg'" alt="">
                        </Tooltip>
                    </template>
                   
                    <div class="page count" v-if="picturePages.length > 4">
                        +{{ picturePages.length - 3 }}
                    </div>
                </div>

                <div class="info" v-if="picturePages.length == 1">
                    <p class="name">{{ pageName }}</p>
                    <p class="google">sur Google</p>
                </div>
              
            </div>
            <div class="card-post">
                <template  v-if="medias.length && medias.find(p => p.type2 == 'image' && p.type !== 'image/gif')" >
                    <div v-for="media in medias.filter(m => m.type2 == 'image' && m.type !== 'image/gif').slice(0,1)" class="post-medias media" :key="media.id">
                        <div class="media">
                            <img :src="media.url" alt="">
                        </div>
                    </div>
                </template>
                
                <div class="snippet" v-else-if="snippet.link">
                    <SnippetNetwork :link="snippet.link"></SnippetNetwork>
                </div>
                <div v-else class="post-empty"></div>

                <div class="content-card-post">
                    <div class="post-text" v-if="text">
                        <p v-html="textTranslateMentionAndHastag"></p>
                    </div>
                
                    <p class="redirection" v-if="snippet.link">
                        <a>En savoir plus  ({{ getHostname(snippet.link) }})</a>
                    </p>
                    <p class="date">{{ datePost ? formatDatePost : 'A l\'instant' }}</p>
                </div>
             
            </div>
          
    
        </div>
    </div>
</template>

<script>
    import { Carousel, Slide } from 'vue-carousel';
    import SnippetNetwork from '../SnippetNetwork.vue'
    import Tooltip from '../../tooltip/tooltipInit.vue'
    export default {
        components: {
            Carousel,
            Slide,
            SnippetNetwork,
            Tooltip
        },

        props: {
            picturePages: {
                type: Array,
                default: ()=>[] 
            },
            pageName : {
                type: String,
                default: ''
            },
            datePost: {
                default: '' 
            },
            medias: {
                type: Array,
                default:  ()=>[] 
            },
            text : {
                type: String,
                default: ''
            },
            snippet: {
                type: Object,
                default: ()=>({
                    link : ""
                })
            },

            mentions: {
                type: Object,
                default: ()=>({})
            }
           
        },

        methods: {
            getHostname(url) {
                return (new URL(url)).hostname.replace("www.", "");
            },
        },

        computed: {
            formatDatePost() {
                let dateMessage = this.datePost
                if (typeof dateMessage !== "object") {
                    dateMessage = new Date(dateMessage)
                }
                let date = new Date()
                let tab_Month= ["Jan", "Févr", "Mars", "Avr", "Mai", "Juin", "Juill", "Août", "Sept", "Oct", "Nov", "Déc"];

                if((date.getDate().toString() + date.getMonth().toString() + date.getFullYear().toString()) == (dateMessage.getDate().toString() + dateMessage.getMonth().toString() + dateMessage.getFullYear().toString())){
                    return "Aujourd'hui à "+dateMessage.getHours()+":"+(dateMessage.getMinutes()<10?'0':'') + dateMessage.getMinutes() ;
                    
                }else if((date.getFullYear() == dateMessage.getFullYear()) && (date.getMonth() == dateMessage.getMonth()) && dateMessage.getDate() == (date.getDate() - 1)){
                    return "Hier à "+dateMessage.getHours()+":"+(dateMessage.getMinutes()<10?'0':'') + dateMessage.getMinutes() ;
                }else{
                    return dateMessage.getDate()+" "+tab_Month[dateMessage.getMonth()]+" "+dateMessage.getFullYear()+" à "+dateMessage.getHours()+":"+(dateMessage.getMinutes()<10?'0':'') + dateMessage.getMinutes()  ;
                }
            },


            textTranslateMentionAndHastag() {
                //return this.text
                return this.text.replace(/@(\d{13})/g, (match, id) => {

                    const mention = this.mentions[id];
                    if (mention) {
                        return mention.mention && mention.mention.google ? `<span class="mention">@${mention.mention.google.id || mention.mention.google.name}</span>` : mention.textDefault;
                    }
                    return match;
                }).replace(/\n/g, '<br>');
              
            }
        },
    }
</script>
